module.exports = __webpack_public_path__ + "static/img/typeTwo.312eafc5.png";